module.exports = __webpack_public_path__ + "img/icon-24.9fc6881b.png";